import { useCallback, useMemo, useState } from "react";
import { useFormik } from "formik";
import { useSelector } from "react-redux";

import api from "services/api";

import serveRequestErrors from "common/serve-request-errors";
import serveRequestSuccess from "common/serve-request-success";

import CONSTANTS from "constants/constant";

import ActionEnum from "enum/action";

import { RootStateDto } from "dto/redux/store-dto";
import ErrorResponseDto from "dto/services/error-response-dto";
import AppResourceArrayInputDto from "dto/components/pages/resources/app-resource-array-input-dto";

import AppInput from "components/app-input";
import AppResourceArrayWrapper from "./app-resource-array-wrapper";

const AppResourceArrayInput = ({ detail }: AppResourceArrayInputDto) => {
	const [focusIndex, setFocusIndex] = useState<null | number>(null);
	const { customerId } = useSelector((state: RootStateDto) => state.profile);
	const initialValues = useMemo(() => {
		if (detail.value?.length > 1 || (detail.value?.length === 1 && !!detail.value[0])) return detail.value as string[];
		else return [""];
	}, [detail.value]);

	const formik = useFormik({
		initialValues: { data: initialValues },
		onSubmit: async (values) => {
			const filterEmptyString = values.data.filter((item: any) => item);

			const payload = {
				id: detail.templateId,
				customerId: customerId,
				template: detail.activeTemplate,
				page: detail.page,
				key: detail.key,
				type: detail.type,
				placeholder: detail.placeholder,
				isArray: detail.isArray,
				value: filterEmptyString,
			};

			try {
				await api.post.resources.update(payload);

				formik.setFieldValue("data", filterEmptyString);

				serveRequestSuccess(CONSTANTS.MESSAGES.UPDATED, ActionEnum.Update);
			} catch (error) {
				const err = error as Error | ErrorResponseDto;

				serveRequestErrors(err);
			}
		},
	});

	const onHandleAdd = useCallback(() => {
		const newData = "";

		const isLastValueEmpty = formik.values.data.length > 0 ? formik.values.data.slice(-1)[0] : true;

		if (isLastValueEmpty) {
			formik.setFieldValue("data", [...formik.values.data, newData]);

			setFocusIndex(formik.values.data.length);
		}
	}, [formik]);

	//prettier-ignore
	const onHandleInputUpdate = useCallback((index: number, event: React.ChangeEvent<HTMLInputElement>) => {
        const updatedValue = event.target.value;

        const updatedData = [...formik.values.data];

        updatedData[index] = updatedValue;

        formik.setFieldValue("data", updatedData);
    }, [formik]);

	//prettier-ignore
	const onHandleDelete = useCallback((index: number) => {
        const dataAfterRemoved = formik.values.data.filter((_, i) => i !== index);

        formik.setFieldValue("data", dataAfterRemoved);
    }, [formik]);

	return (
		<AppResourceArrayWrapper onAdd={onHandleAdd} onUpdate={formik.handleSubmit} title={detail?.label || detail.key}>
			<div className="array-wrapper__inputs">
				{formik.values.data.map((item, index) => (
					<div key={`ai-${index}`} className="array-wrapper__input-wrapper">
						<AppInput type="text" name="data" value={item} placeholder="" onChange={(e) => onHandleInputUpdate(index, e)} defaultActiveIndex={focusIndex === index} onDelete={() => onHandleDelete(index)} />
					</div>
				))}
			</div>
		</AppResourceArrayWrapper>
	);
};

export default AppResourceArrayInput;
